import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmTagBox, mmTagBoxOptions } from "@/types";
import Collapsible from "./collapsible";

class TagBox extends Collapsible<mmTagBoxOptions> implements mmTagBox {
  private _dxTagBox!: DevExpress.ui.dxTagBox;
  
  constructor(element: HTMLElement, options?: mmTagBoxOptions) {
    super(element, options);
    
    this._dxTagBox = ($(this._element) as any)
    .dxTagBox({
      dataSource: this._options.dataSource,
      width: this._options.width,
      displayExpr: this._options.displayExpr,
      valueExpr: this._options.valueExpr,
      placeholder: this._options.placeholder,
       searchEnabled: this._options.searchEnabled,
       value: this._options.value,
       showDropDownButton: this._options.showDropDownButton,
        showClearButton: this._options.showClearButton,
    // //   searchMode: this._options.searchMode,
    //    searchExpr: this._options.searchExpr,
    //    minSearchLength: this._options.minSearchLength,
    //    searchTimeout: this._options.searchTimeout,
    //    openOnFieldClick: this._options.openOnFieldClick,
        readOnly: this._options.readOnly,
        disabled: this._options.disabled,
    //    grouped: this._options.grouped,
// itemTemplate: this._options.itemTemplate 
//   ? this._options.itemTemplate 
//   : (itemData: any) => itemData,
      // fieldTemplate: this._options.fieldTemplate,
      // groupTemplate: this._options.groupTemplate,
      // tagTemplate: this._options.tagTemplate,
    //    stylingMode: this._options.style,
    //    inputAttr: this._options.inputAttr,
    //    hint: this._options.hint,
    //    label: this._options.label,
    //    labelMode: this._options.labelMode,
        acceptCustomValue: this._options.acceptCustomValue,
        onCustomItemCreating: this._options.onCustomItemCreating,
    //    maxDisplayedTags: this._options.maxDisplayedTags,
    //    hideSelectedItems: this._options.hideSelectedItems,
    //    multiline: this._options.multiline,
    //    wrapItemText: this._options.wrapItemText,
    //    showMultiTagOnly: this._options.showMultiTagOnly,
        showSelectionControls: this._options.showSelectionControls,
        selectAllText: this._options.selectAllText,
        selectAllMode: this._options.selectAllMode,
    //    text: this._options.text,
    //    validationStatus: this._options.validationStatus,
    //    validationErrors: this._options.validationErrors,
    //    validationMessageMode: this._options.validationMessageMode,
    //    validationMessagePosition: this._options.validationMessagePosition,
    //  isValid: this._options.isValid,
    //    isDirty: this._options.isDirty,
    //    buttons: this._options.buttons,
    //    deferRendering: this._options.deferRendering,
        dropDownButtonTemplate: this._dropDownButtonTemplate, 
  
    //    rtlEnabled: this._options.rtlEnabled,
    //    focusStateEnabled: this._options.focusStateEnabled,
    //    hoverStateEnabled: this._options.hoverStateEnabled,
    //    height: this._options.height,
    //    tabIndex: this._options.tabIndex,
    //    accessKey: this._options.accessKey,
    //    useItemTextAsTitle: this._options.useItemTextAsTitle,
        name: this._options.name,
    //    opened: this._options.opened,
    //    visible: this._options.visible,
    //    maxLength: this._options.maxLength,

    
       onInitialized: this._options.onInitialized,
       onValueChanged: this._options.onValueChanged,
       onItemClick: this._options.onItemClick,
       onInput: this._options.onInput,
       onSelectionChanged: this._options.onSelectionChanged,
       onClosed: this._options.onClosed,
       onOpened: this._options.onOpened,
       onFocusIn: this._options.onFocusIn,
       onFocusOut: this._options.onFocusOut,
       onKeyDown: this._options.onKeyDown,
       onKeyUp: this._options.onKeyUp,
       onChange: this._options.onChange,
       onOptionChanged: this._options.onOptionChanged,
       onContentReady: this._options.onContentReady,
       onDisposing: this._options.onDisposing,
       onEnterKey: this._options.onEnterKey,
       onMultiTagPreparing: this._options.onMultiTagPreparing,
       onSelectAllValueChanged: this._options.onSelectAllValueChanged,         
        elementAttr: {
          class: generateClassName(
            "tag-box",
            this._options.color!,
            this._options.size!,
            this._options.shape,
            this._options.className,
          ),
          ...(this._options.attributes ?? {}),
        },

        dropDownOptions: {
          ...this._dropDownOptions,
          wrapperAttr: {
            class: generateClassName(
              "dropdown-popup",
              this._options.color == "default" ? "primary" : this._options.color!,
              this._options.size!,
            ),
          },
          width: this._options.dropDownWidth ?? undefined,
          minWidth: this._options.dropDownMinWidth ?? undefined,
        },
      })
      .dxTagBox("instance");
  }

  public getDefaults(): mmTagBoxOptions {
    return {
      color: "default",
      size: "md",
      shape: "normal",
      style: "outlined",
    };
  }

  private _dropDownButtonTemplate = (): JQuery => {
    return $("<div class='dx-icon dx-icon-spindown'>");
  };
}

registerComponent("mmTagBox", TagBox);

export default TagBox;
